import { api } from '@/lib/api/client';
import type { AppointmentSlot, AppointmentSlotQuery, CalendarDayCount, Doctor } from './types';

/** GET /api/users?role=Doctor — see types.ts's Doctor for why this is narrow. */
export function fetchDoctors(): Promise<Doctor[]> {
  return api.get('/users', { query: { role: 'Doctor' } });
}

/**
 * GET /api/appointment-slots — bare array, legacy route. Contract §1
 * deliberately leaves this unpaged: it is filter-driven (doctor/date/status),
 * and paging would break the `from` (no upper bound) "next available slot"
 * lookup this same endpoint serves elsewhere.
 */
export function fetchAppointmentSlots(params: AppointmentSlotQuery): Promise<AppointmentSlot[]> {
  return api.get('/appointment-slots', { query: params as Record<string, string | number> });
}

export function bookSlot(id: number, input: { patient_id: number; visit_id?: number; rebook_of_slot_id?: number }): Promise<AppointmentSlot> {
  return api.post(`/appointment-slots/${id}/book`, input);
}

export function cancelSlot(id: number, reason?: string): Promise<AppointmentSlot> {
  return api.post(`/appointment-slots/${id}/cancel`, { reason });
}

/** POST /api/appointment-slots/:id/no-show — staff record a missed appointment (G6). */
export function markNoShow(id: number): Promise<AppointmentSlot> {
  return api.post(`/appointment-slots/${id}/no-show`, {});
}

/** GET /api/appointment-slots/calendar — counts per day and doctor, ≤ 42 days (G6). */
export function fetchCalendar(from: string, to: string, doctorId?: string): Promise<CalendarDayCount[]> {
  return api.get('/appointment-slots/calendar', { query: { from, to, ...(doctorId ? { doctor_id: doctorId } : {}) } });
}
